import { Table } from '@tanstack/react-table';
import React from 'react';
import { useDrop } from 'react-dnd';

import { IDraggableColumnDndItem } from '@work4all/components/lib/dataDisplay/basic-table/components/table-header/components/header-cell-dnd-wrapper/HeaderCellDndWrapper';

import { DndTypes } from '@work4all/utils/lib/variables';

import { ToolbarDndWrapperDropZone } from './toolbar-dnd-wrapper-drop-zone';

type Props = {
  table: Table<unknown>;
  children: React.ReactNode;
};

export const ToolbarDndWrapperV8 = ({ table, children }: Props) => {
  const [{ showDropZone }, drop] = useDrop({
    accept: DndTypes.BASIC_TABLE_COL,
    drop: (col: IDraggableColumnDndItem) => {
      table.getColumn(col.id)?.toggleGrouping();
    },
    collect: (monitor) => ({
      showDropZone: monitor.canDrop() && monitor.isOver(),
    }),
    canDrop: (col: IDraggableColumnDndItem) => {
      return col.canGroupBy;
    },
  });

  const renderContent = () => {
    if (showDropZone) {
      return <ToolbarDndWrapperDropZone />;
    }

    return children;
  };

  return (
    <div
      ref={(node) => {
        drop(node);
      }}
    >
      {renderContent()}
    </div>
  );
};
